<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    :loading="isLoading"
    ref="form"
  >
    <v-container class="text-center">
      <v-select
        :items="items"
        v-model="localIncident.incidentType"
        data-cy="localIncident-incidentType"
        :label="$$t('incidentType')"
      ></v-select>
      <div class="text-h5">
        {{ $$t('locationTitle') }}
      </div>
      <v-toolbar
        dense
        floating
        style="width: 100%"
      >
        <v-btn icon @click="setCurrentPos">
          <v-icon>{{ mdiCrosshairsGps }}</v-icon>
        </v-btn>
        <GmapAutocomplete @place_changed="setPlace">
        </GmapAutocomplete>
      </v-toolbar>
      <GmapMap ref="map"
      :center="mapPos"
        :zoom="12"
        map-type-id="terrain"
        style="width: 100%; height: 400px"
        @click="mapClick"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false
        }"
      >
        <GmapMarker
          :position="location"
          @dragend="locationDragEnd"
          :clickable="true"
          :draggable="true"
        />
      </GmapMap>
      <ImageUpload v-model="localIncident.imageUrl" />
      <v-img v-show="localIncident.imageUrl" contain :src="localIncident.imageUrl" />
      <div class="text-h5">
        {{ $$t('descriptionTitle') }}
      </div>
      <v-text-field
        class="mt-10"
        filled
        multi-line
        height="300"
        data-cy="localIncident-description"
        :label="$$t('description')"
        v-model="localIncident.description"
      />
      <v-btn block color="success" type="submit" :loading="isLoading">
        {{ $$t('submit') }}
      </v-btn>
      <v-btn
        block
        color="default"
        class="mt-5"
        @click="$router.back()"
      >
        <v-icon small>{{ mdiArrowLeft }}</v-icon>
        {{ $t('common.back')}}
      </v-btn>
    </v-container>
  </v-form>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import { components } from '@codehq/aurora-app-core/src';
import { mdiCrosshairsGps, mdiArrowLeft } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import location from '../mixins/location';

const { ImageUpload } = components;

export default {
  name: 'FormIncident',
  module: 'Incident',
  mixins: [loading, location],
  components: {
    ImageUpload,
  },
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    Incident: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      mdiCrosshairsGps,
      mdiArrowLeft,
      /**
      * Hold incident location detaisl
      */
      location: undefined,
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property editMapItem
      */
      editMapItem: {},
      mapPos: { lat: -28, lng: 26 },
      markers: [],
    };
  },
  computed: {
    google: gmapApi,
    items() {
      return [
        this.$$t('typeLandGrab'),
        this.$$t('typeProtestAction'),
      ];
    },
  },
  watch: {
    Incident() {
      this.localIncident = this.Incident;
    },
  },
  created() {
    this.localIncident = this.Incident;
    this.localIncident.locationNotes = '';
  },
  async mounted() {
    this.isLoading = true;
    await this.refresh();
    const map = await this.$refs.map.$mapPromise;
    this.$log.info('currentPosition', this.currentPosition);
    const mapPos = {
      lat: this.currentPosition.coords.latitude,
      lng: this.currentPosition.coords.longitude,
    };

    map.panTo(mapPos);
    this.setEditMapItem(this.currentPosition?.latLng);
    this.isLoading = false;
  },
  methods: {
    mapClick(e) {
      this.setEditMapItem(e.latLng);
    },
    setEditMapItem(latLng) {
      this.location = latLng;
      this.localIncident.location = {
        geography: {
          wellKnownText: `POINT (${latLng?.lng()} ${latLng?.lat()})`,
        },
      };
    },
    setPlace(place) {
      this.$refs.map.$mapPromise.then((map) => {
        this.$log.info('setPlace', place);
        map.panTo(place.geometry.location);
      });
      // this.place = place;
    },
    setCurrentPos() {
      const self = this;
      navigator.geolocation.getCurrentPosition((pos) => {
        self.mapPos = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        self.$refs.map.$mapPromise.then((map) => {
          map.panTo(self.mapPos);
        });
      });
    },
    locationDragEnd(e) {
      this.$log.debug('locationDragEnd', e);
      this.toggleButton = 1;
      this.mapClick(e);
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (!this.location) {
        this.$root.$emit('notify.error', this.$$t('noLocation'));
      } else if (this.$refs.form.validate()) {
        this.isLoading = true;
        this.$emit('save', this.localIncident);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormIncident example

'''js
<FormIncident :Incident="Incident" />
'''
</docs>
